import { render, staticRenderFns } from "./cfdeRevealV2.vue?vue&type=template&id=c35ccb06&scoped=true"
import script from "./cfdeRevealV2.vue?vue&type=script&lang=js"
export * from "./cfdeRevealV2.vue?vue&type=script&lang=js"
import style0 from "./cfdeRevealV2.vue?vue&type=style&index=0&id=c35ccb06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ccb06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35ccb06')) {
      api.createRecord('c35ccb06', component.options)
    } else {
      api.reload('c35ccb06', component.options)
    }
    module.hot.accept("./cfdeRevealV2.vue?vue&type=template&id=c35ccb06&scoped=true", function () {
      api.rerender('c35ccb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeRevealV2.vue"
export default component.exports